import round from "lodash/round";
import deburr from "lodash/deburr";
import kebabCase from "lodash/kebabCase";
import UAParser from "ua-parser-js";
const userAgentParser = new UAParser();

export default class Utils {
  /* @ngInject */
  constructor($location, $window) {
    this.$location = $location;
    this.$window = $window;
  }

  calculateMarginFromPrice(cost, price) {
    cost = Number(cost);
    price = Number(price);
    if (cost === 0 || price < 0) return 0;
    return round(((price - cost) / cost) * 100, 2);
    // return round(100 - ((100 * cost) / price), 2)
  }

  calculatePriceFromMargin(cost, margin) {
    cost = Number(cost);
    margin = Number(margin);
    return round((margin / 100) * cost + cost, 2);
    // return round(((cost * 100) / (100 - margin)), 2)
  }

  getCurrencyNumberConverted(rates, from, to, number) {
    let numberConverted;
    const numberDollars = number / rates[from];

    if (from === "USD") numberConverted = round(number * rates[to], 2);
    else if (to === "USD") numberConverted = round(number / rates[from], 2);
    else numberConverted = round(numberDollars * rates[to], 2);

    return numberConverted;
  }

  getCurrencyNumberConvertedRound4(rates, from, to, number) {
    let numberConverted;
    const numberDollars = number / rates[from];

    if (from === "USD") numberConverted = round(number * rates[to], 4);
    else if (to === "USD") numberConverted = round(number / rates[from], 4);
    else numberConverted = round(numberDollars * rates[to], 4);

    return numberConverted;
  }

  urlHasHttpProtocol(url) {
    const pattern = /^((http|https):\/\/)/;
    return pattern.test(url);
  }

  removeExternalSrcImgTags(string) {
    const awsRegex = /^https:\/\/s3-eu-west-1\.amazonaws\.com\/quoters-v2\/img\//;
    const filestackRegex = /^https:\/\/cdn\.filestackcontent\.com\//;

    const imgTagArray = string.match(/<img[^>]+>/gi) || [];
    imgTagArray.forEach((imgTag) => {
      const srcWithEqual = imgTag.match(/(src)=("[^"]*")/i);
      const srcValue = srcWithEqual[2].replace(/"/g, "");
      if (!awsRegex.test(srcValue) && !filestackRegex.test(srcValue)) string = string.replace(imgTag, "");
    });

    return string;
  }

  hostname() {
    return this.$location.protocol() + "://" + this.$location.host() + ":" + this.$location.port();
  }

  isBrowserChrome() {
    const userAgentInfo = userAgentParser.setUA(this.$window.navigator.userAgent).getResult();
    return userAgentInfo.browser.name === "Chrome";
  }

  slugify(name) {
    let slug = deburr(name);
    slug = slug.toLowerCase();
    slug = kebabCase(slug);
    return slug;
  }

  filterDiacriticsInsensitive(mapping, language, withInput = false) {
    return function (input, search) {
      let mappedInput = mapping[input][language];

      mappedInput = deburr(mappedInput).toLowerCase();
      search = deburr(search).toLowerCase();

      return withInput
        ? mappedInput.includes(search) || deburr(input).toLowerCase().includes(search)
        : mappedInput.includes(search);
    };
  }
}
